import { render } from "./Habilitacoes.vue?vue&type=template&id=aa96551e"
import script from "./Habilitacoes.vue?vue&type=script&lang=js"
export * from "./Habilitacoes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__